import "react-native-gesture-handler";
import { registerRootComponent } from "expo";
import { setupDatadog } from "./Common/Datadog/utils/datadog";

// eslint-disable-next-line no-undef
if (!__DEV__) {
  setupDatadog();
}

const PatientApp = import("./PatientApp/PatientApp");

registerRootComponent(PatientApp);
